import { isAppStateReady } from 'src/state/store'
import { logger } from '$utils'
import { defer } from 'react-router-dom'
import useStockStore from 'src/components/routes/stock/store'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Suppliers loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Suppliers loader')

  // Load active suppliers only — deleted suppliers fetched on-demand via "Show Deleted" toggle
  const suppliers = useStockStore.getState().getSuppliers(false, false)

  // Return a deferred promise to enable React Router's built-in loading state
  // This approach is currently required for compatibility with our PageLoadingSupport.tsx logic,
  // even though defer() is considered legacy in newer React Router versions.
  return defer({
    data: Promise.all([suppliers])
      .then(() => true)
      .catch((error) => {
        logger.error('Loader Suppliers error: ', error)
        return false
      }),
  })
}
